import axios from "axios";
import { getCurrentSessionIdToken } from "../queries/AuthToken";
import { Attachment, AttachmentsByQuestion } from "../types/attachment";
import { errorToast } from "@idwal/idwal-react-components";

const getInspectionApiHeaders = async () => {
    const token = await getCurrentSessionIdToken();
    return {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + token
    };
};

/**
 * Fetch all attachments for an inspection
 * Returns attachments grouped by questionId for efficient lookup
 */
export const getAttachmentsForInspection = async (
    inspectionId: string
): Promise<AttachmentsByQuestion> => {
    const url = process.env.REACT_APP_INSPECTION_API + `/inspections/${inspectionId}/attachments`;

    const headers = await getInspectionApiHeaders();

    try {
        const response = await axios.get(url, { headers });

        if (response.data?.attachments) {
            // Group attachments by questionId
            const grouped: AttachmentsByQuestion = {};

            for (const attachment of response.data.attachments as Attachment[]) {
                if (!grouped[attachment.questionId]) {
                    grouped[attachment.questionId] = [];
                }
                grouped[attachment.questionId].push(attachment);
            }

            return grouped;
        }

        return {};
    } catch {
        errorToast(`Failed to get attachments for inspection: ${inspectionId}`);
        return {};
    }
};

/**
 * Get attachments for a specific question within an inspection
 */
export const getAttachmentsForQuestion = async (
    inspectionId: string,
    questionId: string
): Promise<Attachment[]> => {
    const url = process.env.REACT_APP_INSPECTION_API + `/inspections/${inspectionId}/attachments?questionId=${encodeURIComponent(questionId)}`;

    const headers = await getInspectionApiHeaders();

    try {
        const response = await axios.get(url, { headers });

        if (response.data?.attachments) {
            return response.data.attachments as Attachment[];
        }

        return [];
    } catch {
        errorToast(`Failed to get attachments for question: ${questionId}`);
        return [];
    }
};
